import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const SectionHead = ({ eyebrow, title, lead, dark = false }) => (
    <Reveal>
        <p
            className={`mb-5 flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.32em] ${
                dark ? "text-gold-light" : "text-gold-dark"
            }`}
        >
            <span className="hidden h-px w-10 bg-gold/70 sm:block" />
            {eyebrow}
        </p>
        <h2
            className={`font-serif text-3xl leading-tight sm:text-4xl lg:text-5xl ${
                dark ? "text-cream" : "text-ink"
            }`}
        >
            {title}
        </h2>
        {lead && (
            <p
                className={`mt-6 max-w-2xl text-base leading-relaxed ${
                    dark ? "text-graphite-mute" : "text-graphite-text"
                }`}
            >
                {lead}
            </p>
        )}
    </Reveal>
);
